/*
  AUTHOR - KHYATI RADADIYA
  COMPANY NAME - RADIX ANALYTICS
  Version - 1
  Change log
    ---------------------------------------------------------------------------------
    Date         Author   Comment
    ---------------------------------------------------------------------------------
    2024-07-10	  Khyati   This is video recording start and ongoing mode action file
*/

import {
  VIDEO_UPLOAD_START_ONLINE_REQUEST,
  VIDEO_UPLOAD_START_ONLINE_SUCCESS,
  VIDEO_UPLOAD_START_ONLINE_FAILURE,
} from "../types";
import axiosInstance from "../../services/axiosInstance";
import { formDataHeader } from "../../services/auth-header";
import recreateAccessTokenAction from "../auth/RecreateAccessTokenAction";

const VideoRecordingStartAction = (payload) => async (dispatch) => {  
  try {
    dispatch({ type: VIDEO_UPLOAD_START_ONLINE_REQUEST });

    const response = await axiosInstance.post(
      `v1/live_stream_process/`,
      payload,
      {
        headers: formDataHeader(),
      }
    );

    dispatch({
      type: VIDEO_UPLOAD_START_ONLINE_SUCCESS,
      payload: response.data,
    });

    return response.data; // Return the data for use in the component
  } catch (error) {
    dispatch({
      type: VIDEO_UPLOAD_START_ONLINE_FAILURE,
      payload: error.message,
    });
    if (error.message === "Request failed with status code 403") {
      dispatch(recreateAccessTokenAction());
    }
    throw error; // Re-throw the error for handling in the component
  }
};

export default VideoRecordingStartAction;
